import { render, staticRenderFns } from "./Chess.vue?vue&type=template&id=54abebda"
import script from "./Chess.vue?vue&type=script&lang=js"
export * from "./Chess.vue?vue&type=script&lang=js"
import style0 from "./Chess.vue?vue&type=style&index=0&id=54abebda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports